import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface BuildingData {
  floor_name: string;
  floor_area: number;
  tenant_name: string;
  tenant_type: string;
  pctg_usage: number;
  used_area: number;
  uom: string;
}

export interface ModalState {
  isOpen: boolean;
  data?: BuildingData[];
  buildingName?: string;
  position?: {
    top: number;
    left: number;
  }
}

@Injectable({
  providedIn: 'root'
})
export class BuildingModalService {
  
  private modalStateSubject = new BehaviorSubject<ModalState | null>(null);
  modalState$ = this.modalStateSubject.asObservable();

  //constructor(private http: HttpClient) {} // Inject HttpClient

  openModal(data: BuildingData[], buildingName?: string): void {
    console.log('Open modal data:', data);
    this.modalStateSubject.next({
      isOpen: true,
      data,
      buildingName
    });
  }

  closeModal(): void {
    this.modalStateSubject.next({
      isOpen: false
    });
  }
}